import React, { useState } from "react";
import {
  Row,
  Col,
  Layout,
  Button,
  Space,
  Spin,
  Tooltip,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import styles from "./Header.module.css";
import { useHistory } from "react-router-dom";
import { ButtonType } from "antd/es/button";
import { loginInfo } from "../../config";
import { updateTable } from "../../api/Api";
interface PropsType {
  setNavNo: Function;
}
export const Header: React.FC<PropsType> = ({ setNavNo }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [buttonTypes, setButtonTypes] = useState<ButtonType[]>([
    "default",
    "default",
    "default",
    "default",
    "default",
  ]);
  const history = useHistory();
  const logout = () => {
    history.push("/");
  };
  const handleOk = async () => {
    let values = form.getFieldsValue();
    if (values.newPwdRepeat !== values.newPwd) {
      message.error("两次输入的密码不一致!");
    } else {
      let data = await updateTable("user", {
        ...loginInfo.user,
        userPwd: values.newPwd,
      });      
      if(typeof data === "undefined"){
        history.push("/");      
      }
        message.info("密码修改成功!");
      
        //message.info("密码修改失败!");
      

      setIsModalVisible(false);
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const modifyPwd = () => {
    form.setFieldsValue({ userCode: loginInfo.user.userCode });
    setIsModalVisible(true);
  };

  const nav = (type: number) => {
    let types: ButtonType[] = [
      "default",
      "default",
      "default",
      "default",
      "default",
    ];
    types[type] = "primary";
    setButtonTypes(types);
    setNavNo(type);
  };

  const [form] = Form.useForm();
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  return (
    <>
      <Layout.Header className={styles["header"]}>
        <Row>
          <Col span={8}>
            <h4 className={styles["header-text"]}>
            阳光尔葆<sup>®</sup>&nbsp;患龋风险评估系统
            </h4>
          </Col>
          <Col span={10}>
            <Space>
              <Button
                type={buttonTypes[0]}
                onClick={() => {
                  nav(0);
                }}
              >
                检测与评估
              </Button>
              <Button
                type={buttonTypes[1]}
                onClick={() => {
                  nav(1);
                }}
              >
                用户管理
              </Button>
              <Button
                type={buttonTypes[2]}
                onClick={() => {
                  nav(2);
                }}
              >
                系统设置
              </Button>
              <Button
                type={buttonTypes[3]}
                onClick={() => {
                  nav(3);
                }}
              >
                统计分析
              </Button>
              <Button
                type={buttonTypes[4]}
                onClick={() => {
                  nav(4);
                }}
              >
                导入导出
              </Button>
            </Space>
          </Col>
          <Col span={4}>
            <Tooltip title="当前登录用户,点击可修改密码">
              <Button
                onClick={modifyPwd}
                size="small"
                type="primary"
                shape="round"
                icon={<UserOutlined />}
              >
                {loginInfo.user.userName}
              </Button>
            </Tooltip>
          </Col>
          <Col span={2}>
            <Tooltip title="点击退出,回到登录界面">
              <Button
                onClick={logout}
                type="default"
                shape="round"
                icon={<LogoutOutlined />}
              />
            </Tooltip>
          </Col>
        </Row>
      </Layout.Header>

      <Modal
        title="修改密码"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="确认"
        cancelText="取消"
      >
        <Form form={form} name="changepwd-form" {...layout}>
          <Form.Item name="userCode" label="当前登录用户">
            <Input disabled={true} />
          </Form.Item>
          <Form.Item name="newPwd" label="新密码" rules={[{ required: true }]}>
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="newPwdRepeat"
            label="重复新密码"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
